import { useEffect } from 'react';

const InstallPrompt = () => {
  useEffect(() => {
    // Listen for the beforeinstallprompt event to prevent the mini-infobar
    const handleBeforeInstallPrompt = (e) => {
      // Prevent the mini-infobar from appearing
      e.preventDefault();
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    };
  }, []);

  // Return null - no popup will be shown
  return null;
};

export default InstallPrompt;
